import React, { useEffect, useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
// import { DataGrid } from '@mui/x-data-grid';
import { SearchInput } from "./SearchInput";
import { CustomLoading, CustomNoRowsOverlay, CustomNoRowsOverlaySubmission, CustomNoTags } from "../utils/tableComponents";
import { Grid } from "@material-ui/core";
import Chip from '@mui/material/Chip';
// import Grid from '@mui/material/Grid';
import "../../styles/devices/mob_SignsTable.css";
import clsx from "clsx";
import { CustomFilters } from "./CustomFilters";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
// import HelpCenterRoundedIcon from '@mui/icons-material/HelpCenterRounded';
import { useDataProvider } from "../../api/DataProvider";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import StyleIcon from '@mui/icons-material/Style';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import PhotoCameraFrontIcon from '@mui/icons-material/PhotoCameraFront';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Tooltip from '@mui/material/Tooltip';
import { useCommProvider } from "../../api/CommProvider";
import { sSearch } from "../../utils/strings";
import { useTour } from "@reactour/tour";
import { stepsSearchText } from "../tour/TourConfig";
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";


/* MOB - Is it neccesary to export this function? It doesn't seem to be used anywhere else. 
  I assume it doesn't really have an impact, but I leave this comment to check it in the future just in case.
*/
export function AddIcon(params) {
  /* Black already seems to be the default color, so we just need classes for the desired states */
  return <SignLanguageIcon className={`sig_ST_SignIcon${ params.row.accesible }`} />;
}

export function SignsTable(props) {
  const { showDialog, favs } = props;
  const { t } = useTranslation("global")

  const { token_id, currentUser, getListAllLemmasAvailable, getListNameDefinitions, getListNameDefinitionsCategories, genEntryByLemma, json_data_USER, json_data_lemma, json_data_glosses } = useDataProvider();

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [taggedRows, setTaggedRows] = useState([]);
  const [searchedRows, setSearchedRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [visibleRows, setVisibleRows] = useState([]);
  const { comm_addHistory, comm_removeHistory } = useCommProvider();
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    { field: "accesible", headerName: "", width: 50, renderCell: (params) => AddIcon(params) },
    { field: "name", headerName: t("sTable.name"), width: 200 },
    // { field: "arr_categories", headerName: "Categorías", flex: 1 },
    { field: "definition", headerName: t("sTable.definition"), flex: 1, renderCell: (params) => showDefinition(params) },
  ];

  function showDefinition(params) {
    let definition = params.row.definition[0];
    console.log("🚀 ~ showDefinition ~ definition:", definition)
    if (definition.length < 5) {
      return <div style={{color:'red'}}> - </div>
    }else{
      return definition;
    }
  }


  /* Sorting, Filtering and Tags */
  const [filterMenuActive, setFilterMenuActive] = useState(false);
  const [tagMenuActive, setTagMenuActive] = useState(false);
  const [sortModel, setSortModel] = useState([{ field: "name", sort: "asc" }]);
  const [filterState, setFilterState] = useState([
    true, // orderAsc
    false, // orderDesc
    true, // showTerm
    true, // showDef
    true, // showAccGreen
    true, // showAccYellow
    true, // showAccRed
    false, // complexSearch
  ]);

  const [inactiveTags, setInactiveTags] = useState([]);
  const [filterTags, setFilterTags] = useState([
    { tagName: sSearch.tagBodyInside.original, isActive: true }, 
    { tagName: sSearch.tagBodyOutside.original, isActive: true },  
    { tagName: sSearch.tagTreatments.original, isActive: true }, 
    { tagName: sSearch.tagExam.original, isActive: true }, 
    { tagName: sSearch.tagIllness.original, isActive: true }, 
    { tagName: sSearch.tagSymptoms.original, isActive: true }, 
    { tagName: sSearch.tagHealthSystem.original, isActive: true }, 
    { tagName: sSearch.tagOther.original, isActive: true }, 
  ]);

  useEffect(() => {
    let arr_lemmas = [];
    if (favs) {
      let r = getListNameDefinitions(json_data_USER['session']['arr_favorites']);
      setRows(r);
      setSearchedRows(r);
      setFilteredRows(r);
      setTaggedRows(r);
      setVisibleRows(r);
      setLoading(false);
    } else {
      arr_lemmas = getListAllLemmasAvailable();
      let r = getListNameDefinitionsCategories(arr_lemmas);
      // console.log("🚀 ~ file: SignsTable.js:73 ~ useEffect ~ getListNameDefinitionsCategories:", r)
      
      setRows(r);
      setSearchedRows(r);
      setFilteredRows(r);
      setTaggedRows(r);
      setVisibleRows(r);
      setLoading(false);
    }
  }, [favs, json_data_USER]);

  /* Click cell */
  function handleRowClick(params, event) {
    try {
      showDialog([rows[params.id]["_id"]]);
      comm_addHistory(token_id, currentUser, rows[params.id]["_id"], Date.now())
    } catch(err){
      console.error(err)
    }
  }

  /* Search */
  /* MOB - I added the functionality for searching within term definitions if the appropiate option
  is selected in the filter menu. It is pending review, but uses the same structure as the usual search, 
  and the conditional should always exit before any 'expensive' line of code if the 'advanced search' is not turned on. */
  function handleSearch(e) {
    const search = e.target.value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    var sr = [];

    if (search.length < 4){
      rows.forEach((i) => {
        try {
          if (
            i["name"]
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .startsWith(search)
              // .includes(search)
          ) {
            sr.push(i);
          } else if ((filterState[7] === true) && (
            i["definition"][0]
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(search)
            )) {
              sr.push(i);
            }
        } catch {}
      });
    } else {
      rows.forEach((i) => {
        try {
          if (
            i["name"]
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              // .startsWith(search)
              .includes(search)
          ) {
            sr.push(i);
          } else if ((filterState[7] === true) && (
            i["definition"][0]
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(search)
            )) {
              sr.push(i);
            }
        } catch {}
      });
    }
    setSearchedRows(sr);
    mixFilters(sr, filteredRows, taggedRows);
  }

  /* Pagination */
  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  /* Custom Filtering */
  /* MOB - At first, I attempted to use the columnVisibilityModel provided by MUI, but it
    doesn't seem to work consistently, at least in this version, so I opted to use pure css instead. */


  const deactivateAllTags = () => {
    // console.log('RESET ALL TAAGS')
    const updatedFilterTags = filterTags.map(tag => ({
      ...tag,
      isActive: false,
    }));
    setFilterTags(updatedFilterTags);
    setTaggedRows([]);
    mixFilters(searchedRows, filteredRows, []);
  };

  const activateAllTags = () => {
    // console.log('ACTIVATE ALL TAAGS')
    const updatedFilterTags = filterTags.map(tag => ({
      ...tag,
      isActive: true,
    }));
    setFilterTags(updatedFilterTags);
    setTaggedRows(rows);
    mixFilters(searchedRows, filteredRows, rows);
  };

  const handleFilterOptions = (event, filterId, newFilterState) => {
    console.log("🚀 ~ handleFilterOptions ~ newFilterState:", newFilterState)
    switch (filterId) {
      case 0:
      case 1:
        if (sortModel[0]['sort'] === 'asc') {
          setSortModel([{ field: "name", sort: "desc" }]);
        } else {
          setSortModel([{ field: "name", sort: "asc" }]);
        }
        break;

      case 4:
      case 5:
      case 6:  
        console.log('ROWS2222: ', rows)
        const fAccessible = ["GREEN", "YELLOW", "RED"];
        const fr = rows.filter((term) => 
          (newFilterState[4] && (term["accesible"][0] === fAccessible[0])) || 
          (newFilterState[5] && (term["accesible"][0] === fAccessible[1])) ||
          (newFilterState[6] && (term["accesible"][0] === fAccessible[2])) 
          );         
        setFilteredRows(fr);
        mixFilters(searchedRows, fr, taggedRows);
        break;

      default: break;
    }
    setFilterState(newFilterState);
  };

  useEffect(() => {
    console.log("🚀 ~ SignsTable ~ filteredRows:", filteredRows)
  }, [filteredRows]);
  

  function handleFilterMenu() {
    setFilterMenuActive((state) => !state);
  }

  function handleTagMenu() {
    if (tagMenuActive === false){
      deactivateAllTags()
    }else{
      activateAllTags()
    }
    setTagMenuActive((state) => !state);
  }

  /* Tour */
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  /* Tags */
  function handleTagClick(tagString) {
    const activeTags = [];
    const newFilterTags = filterTags.map((tag) => {
      if (tag.tagName === tagString) {
        if (!tag.isActive) { activeTags.push(tag.tagName); }
        return { ...tag, isActive: !tag.isActive };
      } else {
        if (tag.isActive) { activeTags.push(tag.tagName); }
        return tag;
      }
    });
    setFilterTags(newFilterTags);
    
    const tr = rows.filter(term => term["arr_categories"][0].some(tag => activeTags.includes(tag)));    
    setTaggedRows(tr);
    mixFilters(searchedRows, filteredRows, tr);
  }

  /* Mix filters */
  function mixFilters(sr, fr, tr) {
    console.log("🚀 ~ mixFilters ~ sr:", sr)
    console.log("🚀 ~ mixFilters ~ fr:", fr)
    console.log("🚀 ~ mixFilters ~ tr:", tr)
    const vr = rows.filter(r => (sr.includes(r) && fr.includes(r) && tr.includes(r)));
    setVisibleRows(vr);
  }

  const history = useHistory();
  function handleOpenSubmissionScreen(){
    history.push({pathname: "/submission", origin: '/search'});
  }

  return (
    <div className="sig_ST_Root">
      <Grid container direction="column">
        <div className={`sig_ST_CustomFilters_MenuBkg ${filterMenuActive ? "" : "sig_ST_CustomFilters_MenuBkg_Hidden"}`} onClick={handleFilterMenu}></div>
        <Grid data-tour="tourText_4" item className="sig_SignsDB_SearchContainer">
          <SearchInput disabled={loading} handleSearch={handleSearch} />   
          <div className="sig_ST_SearchButtonsContainer">      
            <Tooltip title={t("sTooltip.filters_options")} placement='bottom-end' arrow>
              <div className="sig_Main_IconButton" onClick={handleFilterMenu}>
                {filterMenuActive ? <FilterAltIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" /> : <FilterAltOutlinedIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />}
              </div>
            </Tooltip>          
            <Tooltip title={t("sTooltip.tags")} placement='bottom' arrow>
              <div className={`${tagMenuActive ? 'sig_Main_IconButtonActive' : ''} sig_Main_IconButton`} onClick={handleTagMenu}>
                <StyleIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />
              </div>
            </Tooltip>
            <Tooltip title={t("sTooltip.submission")} placement="bottom-end" arrow>
              <div className="sig_Main_IconButton" onClick={() => handleOpenSubmissionScreen()}>
                <AddCircleIcon className="sig_Home_ChangeOnDarkMode"/>
              </div>
            </Tooltip>
            <Tooltip title={t("sTooltip.show_help")} placement="bottom-end" arrow>
              <div data-tour="tourText_1" className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsSearchText, 0)}>
                <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
              </div>
            </Tooltip>
          </div> 
        </Grid>
        <Grid item className={`${tagMenuActive ? '' : 'sig_ST_Tags_Root_Hidden'} sig_ST_Tags_Root`}>          
          <div className="sig_ST_Tags_Menu">
            <div className="sig_ST_Tags_Header">
              {sSearch.tagTitle}
            </div>
            <div className="sig_ST_Tags_Container">
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagBodyInside.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagBodyInside.label} 
                onClick={() => handleTagClick(sSearch.tagBodyInside.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagBodyOutside.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagBodyOutside.label} 
                onClick={() => handleTagClick(sSearch.tagBodyOutside.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagTreatments.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagTreatments.label} 
                onClick={() => handleTagClick(sSearch.tagTreatments.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagExam.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagExam.label} 
                onClick={() => handleTagClick(sSearch.tagExam.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagIllness.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagIllness.label} 
                onClick={() => handleTagClick(sSearch.tagIllness.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagSymptoms.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagSymptoms.label} 
                onClick={() => handleTagClick(sSearch.tagSymptoms.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagHealthSystem.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagHealthSystem.label} 
                onClick={() => handleTagClick(sSearch.tagHealthSystem.original)} 
              />
              <Chip 
                className={`${filterTags.find(t => t.tagName === sSearch.tagOther.original).isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                label={sSearch.tagOther.label} 
                onClick={() => handleTagClick(sSearch.tagOther.original)} 
              />
            </div>
          </div>
        </Grid>
        <Grid item className={`${tagMenuActive ? '' : 'sig_ST_DataGrid_Root_ShiftUp'} sig_ST_DataGrid_Root`}>
          <DataGrid
            className={clsx("sig_ST_DataGrid", {
              sig_ST_HiddenTerm: !filterState[2],
              sig_ST_HiddenDef: !filterState[3],
            })}
            autoHeight
            getRowClassName={(params) => `sig_ST_HiddenAcc${params.getValue(params.id, 'accesible')}`}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            disableSelectionOnClick
            sortModel={sortModel}
            loading={loading}
            columns={columns}
            rows={visibleRows}
            onRowClick={handleRowClick}
            components={{
              LoadingOverlay: CustomLoading,
              NoRowsOverlay: favs ? CustomNoRowsOverlay : taggedRows.length === 0 ? CustomNoTags : CustomNoRowsOverlaySubmission,
              /* Toolbar: CustomToolbar */
            }}
          />
        </Grid>
      </Grid>
      <CustomFilters active={filterMenuActive} handleFilterOptions={handleFilterOptions} handleFilterMenu={handleFilterMenu} />
    </div>
  );
}
